import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
const MainFooter = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const handleBackToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-light  py-1">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <p className="mb-0 text-center w-100">
          Copyright &copy; 2024–{currentYear} {t("footerCopyRightMessageFirstPart")} 
          <a target="_blank" href="http://www.tu-sofia.bg/" className="footerLink">TUS Bulgaria</a>. 
          {' '+t("footerCopyRightMessageSecondPart")} 
        </p>
        <Link
          to="#"
          className="btn btn-danger rounded-circle float-end"
          onClick={handleBackToTop}
          aria-label="Back to top"
        >
          <i className="bi bi-arrow-up"></i>
        </Link>
      </div>
    </footer>
  );
};

export default MainFooter;
